const getBaseUrl = () => {
    return 'https://et-pos.store/connector/api/plaid';
};

function getToken() {
    return localStorage.getItem('etpos_token') || '';
}

function headers() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${getToken()}`,
        'X-Requested-With': 'XMLHttpRequest',
    };
}

async function request(method, path, body) {
    const opts = { method, headers: headers(), cache: 'no-store' };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(`${getBaseUrl()}${path}`, opts);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || `Request failed: ${res.status}`);
    return data;
}

export const plaidApi = {
    getCredentials:       ()               => request('GET',    '/credentials'),
    saveCredentials:      (body)           => request('POST',   '/credentials', body),
    createLinkToken:      ()               => request('POST',   '/create-link-token'),
    exchangePublicToken:  (public_token, metadata)   => request('POST',   '/exchange-public-token', { public_token, metadata }),
    getItems:             ()               => request('GET',    '/items'),
    getAccounts:          ()               => request('GET',    '/accounts'),
    getTransactions:      (params = {})    => {
        const query = new URLSearchParams(params).toString();
        return request('GET', `/transactions${query ? `?${query}` : ''}`);
    },
    syncTransactions:     (body = {})      => request('POST',   '/sync-transactions', body),
    reconcileTransaction: (body)           => request('POST',   '/reconcile', body),
    removeItem:           (id)             => request('POST',   `/items/${id}/disconnect`),
};
